
import { defineComponent, onMounted } from "vue";
import AssessoreList from "@/views/Pending/list/AssessoreList.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "dashboard",
  components: {
    AssessoreList,
  },
  data() {
    return {
      data: "",
    };
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Dashboard");
    });
  },
});
